import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cuserfunction(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  
return(
    <div>
            <Sides/>
            <Helmet>
 
 <title>User-defined function in C tutorial For Beginners</title>
 <meta name="description" content="User-defined function c tutorial for beginners.The program can define its own function and a function consist of the following.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c user define function,user defined function in c,example of user defined function in c,user defined function in c language,user defined function program in c,user defined function in c programming,define user defined function in c,how to define user defined function in c,user defined function factorial in c,c define function pointer" />
 <link rel="canonical" href="https://www.codeexampler.com/c-user-defined-function" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">User-defined function in a c programming language
</h1>
<div className="first">
        <a href="/c-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">The program can define its function, and a process consists of the following.
</p>

<h2 className="mt-4 mh2">There are Five types of User-defined functions:
</h2>

<h3 className="mt-4 mh3">1, Function prototype(declaration)<br/>
2, Function definition<br/>
3, Calling function (accessing)<br/>
4, Function argument(parameter)<br/>
5, Return value by the function<br/>
</h3>



<h2 className='headings'>Q-Write a program print (hello function) by Calling using a user defined function in the C programming?</h2>
   <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{maxHeight:"100vh"}}>
      <code >
        {"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-10">stdio.h</span>
            <span className="qwerty-4">&#62; </span>
        {"\n"}
            <span className="qwerty-3">void </span>
            <span className="qwerty-2">hello</span>
            <span className="qwerty-4"> ()</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
        <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">hello function \n</span>
            <span className="qwerty-4">");</span>
        {"\n"}
        <span className="qwerty-4">&#125;</span>
        {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">main</span>
            <span className="qwerty-4"> ()</span>
        {"\n"}
            <span className="qwerty-4" >&#123; </span>
        {"\n"}
            <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">This is a function program \n</span>
            <span className="qwerty-4">");</span>
        {"\n"}
          <span className="qwerty-2"> hello</span>
            <span className="qwerty-4"> ();</span>
            <span className="qwerty-5">//calling function</span> 
          {"\n"}
            <span className="qwerty-8"> printf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-10">hello is a function</span>
            <span className="qwerty-4">");</span>
        {"\n"}
            <span className="qwerty-7"> return</span>
            <span className="qwerty-3"> 0</span>
            <span className="qwerty-4">; </span>
        {"\n"}
            <span className="qwerty-4">&#125;</span>
    </code>
    </pre>
    </div>          
    <h4 className='headings'>Output :</h4>
     <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
            <code >
                {"\n"}
                    <span className="qwerty-10">This is a function program</span>
                {"\n"}
                    <span className="qwerty-3">hello function</span>
                {"\n"}
                    <span className="qwerty-4">hello is a function</span>
                {"\n"}{"\n"}
                </code>
            </pre>
            </div>   



<h2 className='headings'>Q-What will be the output of the following function program when a person goes from the USA to stay in the UK and create a plane to travel to India?</h2>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
        <pre style={{maxHeight:"100vh"}}>
            <code >
              {"\n"}
                  <span className="qwerty-7">#include </span>
                  <span className="qwerty-4">&#60;</span>
                  <span className="qwerty-10">stdio.h</span>
                  <span className="qwerty-4">&#62; </span>
              {"\n"}
                  <span className="qwerty-3">void </span>
                  <span className="qwerty-2">USA</span>
                  <span className="qwerty-4"> ()</span>
              {"\n"}
                  <span className="qwerty-4" >&#123; </span>
              {"\n"}
              <span className="qwerty-8"> printf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-10">USA journey \n</span>
                  <span className="qwerty-4">");</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
                  <span className="qwerty-3">void </span>
                  <span className="qwerty-2">UK</span>
                  <span className="qwerty-4"> ()</span>
              {"\n"}
                  <span className="qwerty-4" >&#123; </span>                  
              {"\n"}
                <span className="qwerty-2"> USA</span>
                  <span className="qwerty-4"> ();</span>
              {"\n"}
              <span className="qwerty-8"> printf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-10">UK journey \n</span>
                  <span className="qwerty-4">");</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
                  <span className="qwerty-3">int </span>
                  <span className="qwerty-2">main</span>
                  <span className="qwerty-4"> ()</span>
              {"\n"}
                  <span className="qwerty-4" >&#123; </span>
              {"\n"}
                  <span className="qwerty-8"> printf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-10">travel start \n</span>
                  <span className="qwerty-4">");</span>
              {"\n"}
                <span className="qwerty-2"> UK</span>
                  <span className="qwerty-4"> ();</span>
                {"\n"}
                  <span className="qwerty-8"> printf</span>
                  <span className="qwerty-4">("</span>
                  <span className="qwerty-10">India journey</span>
                  <span className="qwerty-4">");</span>
              {"\n"}
                  <span className="qwerty-7"> return</span>
                  <span className="qwerty-3"> 0</span>
                  <span className="qwerty-4">; </span>
              {"\n"}
                  <span className="qwerty-4">&#125;</span>
          </code>
          </pre>
          </div>          
          <h4 className='headings'>Output :</h4>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                  <code >
                      {"\n"}
                          <span className="qwerty-8">travel start</span>
                      {"\n"}
                          <span className="qwerty-1">USA journey</span>
                      {"\n"}
                          <span className="qwerty-3">UK journey</span>
                      {"\n"}
                          <span className="qwerty-8">India journey</span>
                      {"\n"}{"\n"}
                      </code>
                  </pre>
                  </div> 

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-passing-argument"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cuserfunction;